import React, { useEffect, useRef } from 'react';

import { ensureTrustpilotBootstrap } from './ensureTrustpilotBootstrap';

const BUSINESS_UNIT_ID = '60c847b7f033d300019ff3a1';
const TEMPLATE_ID = '53aa8912dec7e10d38f59f36';

export type CarouselSubject = 'chinese' | 'english' | 'math';

/**
 * 各学科的 Carousel 在 Trustpilot 后台单独生成：
 * token 与 tags（按学科筛选评价）均不同
 */
const SUBJECT_CONFIG: Record<
  CarouselSubject,
  { token: string; tags?: string }
> = {
  chinese: {
    token: 'f37abc4a-4d25-4c5a-acf9-3372b0428a9d',
    tags: 'Chineselesson',
  },
  english: {
    token: '0ab77e47-b77b-4dfe-bd4f-79a1ae24fafb',
    tags: 'ELA',
  },
  math: {
    token: 'c213822f-9a91-40e1-b51c-7533b4a711e6',
    tags: 'Math',
  },
};

/**
 * Trustpilot 官方 TrustBox：Carousel（评价轮播）
 * bootstrap 由组件内部加载，页面无需再写 script
 */
const TrustpilotCarousel: React.FC<{
  subject?: CarouselSubject;
  className?: string;
}> = ({ subject = 'chinese', className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { token, tags } = SUBJECT_CONFIG[subject];

  useEffect(() => {
    let cancelled = false;

    ensureTrustpilotBootstrap()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {
        // bootstrap 加载失败时保留占位链接，不阻断页面
      });

    return () => {
      cancelled = true;
    };
  }, [token, tags]);

  return (
    <div className={className}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id={TEMPLATE_ID}
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height="140px"
        data-style-width="100%"
        data-token={token}
        data-tags={tags}
        data-stars="5"
        data-review-languages="en"
        data-text-color="#1B1F4D">
        <a
          href="https://www.trustpilot.com/review/wukongsch.com"
          target="_blank"
          rel="noopener">
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default TrustpilotCarousel;
